import { io } from "socket.io-client";

const socket = io("https://api.skyguard.group/api", {
  transports: ["websocket","polling"],
});

export default socket;